const textMediaElementsRight = document.querySelectorAll('.textMedia.media--right')

const changeOrderOfTextMedia = () => {
    if (window.innerWidth >= 1300) {
        textMediaElementsRight.forEach(textmedia => {
            const text = textmedia.querySelector('.textContent')
            text.remove()
            textmedia.prepend(text)
        })
    }
    if (window.innerWidth < 1300) {
        textMediaElementsRight.forEach(textmedia => {
            const text = textmedia.querySelector('.textContent')
            text.remove()
            textmedia.append(text)
        })
    }
}

window.addEventListener('resize', () => {
    changeOrderOfTextMedia()
});

changeOrderOfTextMedia()